export default "__VITE_ASSET__d259de74__"